import React, { Fragment } from 'react';
import { GridColumn } from '@atlaskit/page';
import { TextField, DatePickerField, SelectField } from '../../../components/FormFields';
import { FormFooter } from '@atlaskit/form';
import Button, { ButtonGroup } from '@atlaskit/button';
import { Trans } from 'react-i18next';
import i18n from 'i18next';
import { EditViewContext } from './EditViewContext';
import ViewForm, { ViewFormField } from './ViewForm';

export const FotaCarFields = ({
  vin,
  iccid,
  reference,
  firmwareVersion,
  bodyType,
  year,
  configuration,
  model,
  firmwareStatus,
  onChange,
  fetching,
  dictionaries,
  getDictionaries,
}) => (
  <Fragment>
    <GridColumn medium={12}>
      <TextField
        name='vin'
        label={i18n.t('fota:VIN')}
        placeholder={i18n.t('fota:Enter VIN')}
        required={true}
        onChange={onChange}
        isDisabled={fetching}
        value={vin}
      />
    </GridColumn>
    <GridColumn medium={6}>
      <TextField
        name='iccid'
        label={i18n.t('fota:ICCID')}
        placeholder={i18n.t('fota:Enter ICCID')}
        required={true}
        onChange={onChange}
        isDisabled={fetching}
        value={iccid}
      />
    </GridColumn>
    <GridColumn medium={6}>
      <TextField
        name='reference'
        label={i18n.t('fota:Reference')}
        placeholder={i18n.t('fota:Enter Reference')}
        required={true}
        onChange={onChange}
        isDisabled={fetching}
        value={reference}
      />
    </GridColumn>
    <GridColumn medium={6}>
      <TextField
        name='firmwareVersion'
        label={i18n.t('fota:Firmware Version')}
        placeholder={i18n.t('fota:Enter Firmware Version')}
        required={true}
        onChange={onChange}
        isDisabled={fetching}
        value={firmwareVersion}
      />
    </GridColumn>
    <GridColumn medium={6}>
      <SelectField
        name='bodyType'
        label={i18n.t('fota:Body Type')}
        placeholder={i18n.t('fota:Select Body Type')}
        isMulty={false}
        value={bodyType}
        required={false}
        onChange={onChange}
        data={dictionaries.genders.data}
        fetching={dictionaries.genders.fetching}
        getData={getDictionaries('genders')}
        isDisabled={fetching}
      />
    </GridColumn>
    <GridColumn medium={6}>
      <DatePickerField
        name='year'
        label={i18n.t('fota:Year')}
        placeholder={i18n.t('ddmmyyyy')}
        required={false}
        onChange={onChange}
        isDisabled={fetching}
        value={year}
      />
    </GridColumn>
    <GridColumn medium={6}>
      <TextField
        name='configuration'
        label={i18n.t('fota:Configuration')}
        placeholder={i18n.t('fota:Enter Configuration')}
        required={false}
        onChange={onChange}
        isDisabled={fetching}
        value={configuration}
      />
    </GridColumn>
    <GridColumn medium={6}>
      <TextField
        name='model'
        label={i18n.t('fota:Model')}
        placeholder={i18n.t('fota:Enter Model')}
        required={false}
        onChange={onChange}
        isDisabled={fetching}
        value={model}
      />
    </GridColumn>
    <GridColumn medium={6}>
      <SelectField
        name='firmwareStatus'
        label={i18n.t('fota:Firmware Status')}
        placeholder={i18n.t('fota:Select Firmware Status')}
        isMulty={false}
        value={firmwareStatus}
        required={false}
        onChange={onChange}
        data={dictionaries.genders.data}
        fetching={dictionaries.genders.fetching}
        getData={getDictionaries('genders')}
        isDisabled={fetching}
      />
    </GridColumn>
  </Fragment>
);

const FotaCarEditForm = ({
  vin,
  iccid,
  reference,
  firmwareVersion,
  bodyType,
  year,
  configuration,
  model,
  firmwareStatus,
  onChange,
  dictionaries,
  getDictionaries,
  fetching,
  onCancel,
}) => (
  <Fragment>
    <FotaCarFields
      vin={vin}
      iccid={iccid}
      reference={reference}
      firmwareVersion={firmwareVersion}
      bodyType={bodyType}
      year={year}
      configuration={configuration}
      model={model}
      firmwareStatus={firmwareStatus}
      onChange={onChange}
      dictionaries={dictionaries}
      getDictionaries={getDictionaries}
      fetching={fetching}
    />
    <GridColumn medium={12}>
      <FormFooter>
        <ButtonGroup>
          <Button appearance='subtle' isDisabled={fetching} onClick={onCancel}>
            <Trans>Cancel</Trans>
          </Button>
          <Button type='submit' isDisabled={fetching} isLoading={fetching} appearance='danger'>
            <Trans>Save</Trans>
          </Button>
        </ButtonGroup>
      </FormFooter>
    </GridColumn>
  </Fragment>
);

const FotaCarViewForm = ({
  vin,
  iccid,
  reference,
  firmwareVersion,
  bodyType,
  year,
  configuration,
  model,
  firmwareStatus,
}) => (
  <Fragment>
    <ViewFormField label={i18n.t('fota:VIN')} value={vin} gridColumn={12} />
    <ViewFormField label={i18n.t('fota:ICCID')} value={iccid} gridColumn={6} />
    <ViewFormField label={i18n.t('fota:Reference')} value={reference} gridColumn={6} />
    <ViewFormField label={i18n.t('fota:Firmware Version')} value={firmwareVersion} gridColumn={6} />
    <ViewFormField label={i18n.t('fota:Body Type')} value={bodyType.name} gridColumn={6} />
    <ViewFormField label={i18n.t('fota:Year')} value={year} gridColumn={6} />
    <ViewFormField label={i18n.t('fota:Configuration')} value={configuration} gridColumn={6} />
    <ViewFormField label={i18n.t('fota:Model')} value={model} gridColumn={6} />
    <ViewFormField label={i18n.t('fota:Firmware Status')} value={firmwareStatus.name} gridColumn={6} />
  </Fragment>
);

export default props => {
  const formName = 'fotaCar';
  return (
    <EditViewContext.Consumer>
      {({ edit, permissions, onChangeEditMode, onChange }) => (
        <ViewForm
          formName={formName}
          title={i18n.t('fota:Fota Car')}
          actionName={/*permissions && permissions.edit && */ i18n.t('fota:Edit')}
          action={onChangeEditMode(formName)}
          editMode={edit === formName}
        >
          {edit === formName
            ? <FotaCarEditForm {...props} onChange={onChange} />
            : <FotaCarViewForm {...props} />
          }
        </ViewForm>
      )}
    </EditViewContext.Consumer>
  );
};